import Observer from "../../observer/observer.js";

import SuggestionsListView from "../view/suggestions-list.js";
import SuggestionItemView from "../view/suggestion-item.js";

import Animation from "../../animation/animation.js";

import {
  render,
  removeElement
} from "../../render/render.js";

import {
  ActionType
} from "../const.js";

export default class Suggestions extends Observer {
  constructor(container, suggestions) {
    super();

    this._container = container;
    this._suggestions = suggestions;

    this._animation = new Animation();

    this._listView = null;
    this._itemsViews = [];

    this._handleSuggestionItemButtonClick = this._handleSuggestionItemButtonClick.bind(this);
  }

  init() {
    this._listView = new SuggestionsListView();

    render(this._container, this._listView.getElement());

    this._suggestions.forEach((suggestion) => {
      const view = new SuggestionItemView(suggestion);
      render(this._listView.getElement(), view.getElement());
      view.setButtonClickHandler(this._handleSuggestionItemButtonClick);
      this._itemsViews.push(view);
    });

    this._animation.appear(
        this._listView.getElement()
    );
  }

  destroy() {
    const listElement = this._listView.getElement();
    this._listView = null;
    this._itemsViews = [];

    this._animation.disappear(
        listElement,
        null,
        () => {
          removeElement(listElement);
        }
    );
  }

  _handleSuggestionItemButtonClick(selectedText) {
    this._notify(ActionType.ITEM_SELECT, {
      selectedText
    });
  }
}
